module.exports = __webpack_public_path__ + "img/餐饮小票.03abf212.jpg";